import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "CS Student at Scaler & BITS Pilani",
          "Full Stack Developer",
          "AI Safety Researcher",
          "AI/ML Engineer",
          "React Native Developer",
          "Building with RAG & Vector DBs",
          "Open Source Contributor",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
